import Layout from '@/layout/paycools-index.vue'

export const paymentLinkRouter = {
  path: '/paymentLink',
  component: Layout,
  redirect: '/paymentLink/list',
  name: 'Payment_Link',
  meta: { title: 'payment_link', icon: 'payment-link' },
  alwaysShow: true,
  children: [
    {
      path: 'list',
      name: 'Payment_Link_List',
      component: () => import('@/views/paycools/payment-link/list.vue'),
      meta: {
        title: 'payment_link', noCache: false,
        auth: ['AUTH_CODE_PAYMENT_LINK']
      }
    },
    {
      path: 'createEditPaymentLink',
      name: 'Create_Edit_Payment_Link',
      component: () => import('@/views/paycools/payment-link/createEditPaymentLink.vue'),
      hidden: true,
      meta: {
        title: 'payment_link', noCache: false,
        auth: ['AUTH_CODE_PAYMENT_LINK']
      }
    },
    {
      path: 'createEditSubPaymentLink/:sub_merchant_no',
      name: 'Create_Edit_Sub_Payment_Link',
      component: () => import('@/views/paycools/sub-merchant/components/content/payment-link/createEditPaymentLink.vue'),
      hidden: true,
      meta: {
        title: 'payment_link', noCache: false,
        auth: ['AUTH_CODE_PAYMENT_LINK']
      }
    }
  ]
}
